<mat-drawer-container class="sidenav-container" autosize>
    <mat-drawer #drawer class="sidenav-drawer mat-elevation-z20" mode="over">
        <mat-toolbar class="toolbar-heading">
            <span>Menu</span>
        </mat-toolbar>

        <mat-nav-list>
            <a mat-list-item (click)="drawer.toggle()" *ngFor="let opts of menuOptions" [routerLink]="[opts.routePath]">
                {{opts.name}} <mat-icon>chevron_right</mat-icon>
            </a>
        </mat-nav-list>

    </mat-drawer>

    <div class="main-content">
        <mat-toolbar color="primary" class="mainNav">
            <span id="name">Abel Tom Varghese</span>
            <div>
                <button mat-button (click)="drawer.toggle()" class="menuButtonContainer" >
                    <mat-icon id="menuIcon">menu</mat-icon>
                </button>
            </div>
        </mat-toolbar>

        
        <div class="wrapper">
            <router-outlet></router-outlet>
        </div>

    </div>
    <footer color="primary">
        <span id="name">Abel Tom Varghese</span>
    </footer>
</mat-drawer-container>